import { TASK_CATEGORY_BG_COLORS } from '../constants';
import { TaskCategory } from '../types';

export const zeroPadId = (id: number) => {
  const string = id.toString();

  if (string.length < 4) {
    return `0000${string}`.slice(-4);
  }

  return string;
};

export const getTaskCategoryColor = (category: TaskCategory): string => {
  return TASK_CATEGORY_BG_COLORS[category] || '';
};
